/**
 * Landeseite für die Links aus den Newsletter-Mails (newsletter.ts): die
 * Bestätigung des Double-Opt-in und die Abmeldung. Beides hat schon die
 * billing-Function erledigt, bevor sie hierher weiterleitet (Supabase liefert
 * aus Functions kein HTML aus). Ohne Anmeldung erreichbar.
 */

import { Hinweis, Rahmen } from '../ui';
import { t } from '../sprache';

const SUPPORT_ADRESSE = 'run@99takes.com';

export default function Newsletter() {
  const p = new URLSearchParams(window.location.search);
  if (p.has('bestaetigt')) {
    return (
      <Rahmen titel={t('Du bist angemeldet', 'You are subscribed')} unter={t('Danke, der Newsletter von 99takes kommt ab jetzt an diese Adresse.', 'Thanks, the 99takes newsletter now goes to this address.')}>
        <p className="m-0 text-[0.9375rem] leading-relaxed text-text-leise">
          {t('Abmelden kannst du dich jederzeit über den Link in jeder Mail oder im Konto.', 'You can unsubscribe at any time with the link in every email or in your account.')}
        </p>
      </Rahmen>
    );
  }
  if (p.has('abgemeldet')) {
    return (
      <Rahmen titel={t('Du bist abgemeldet', 'You are unsubscribed')} unter={t('Den Newsletter von 99takes bekommst du nicht mehr.', 'You will no longer get the 99takes newsletter.')}>
        <p className="m-0 text-[0.9375rem] leading-relaxed text-text-leise">
          {t('Mails, die zu deinem Konto gehören, etwa ein neues Passwort, kommen weiter an.', 'Emails that belong to your account, such as a new password, still arrive.')}
        </p>
      </Rahmen>
    );
  }
  return (
    <Rahmen titel={t('Das hat nicht geklappt', 'That did not work')} unter={t('Der Link war unvollständig oder ist abgelaufen.', 'The link was incomplete or has expired.')}>
      <Hinweis art="schlecht">
        {t(
          <>Melde dich im Konto erneut an, dann schicken wir dir einen neuen Link. Oder schreib an <a href={`mailto:${SUPPORT_ADRESSE}`} className="text-marke-tief underline">{SUPPORT_ADRESSE}</a>.</>,
          <>Subscribe again in your account and we will send you a new link. Or write to <a href={`mailto:${SUPPORT_ADRESSE}`} className="text-marke-tief underline">{SUPPORT_ADRESSE}</a>.</>,
        )}
      </Hinweis>
    </Rahmen>
  );
}
